// Modules
import React from "react";

const TvCabinetIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path d="M496,248H304v-8h64a8,8,0,0,0,8-8V104a8,8,0,0,0-8-8H144a8,8,0,0,0-8,8V232a8,8,0,0,0,8,8h64v8H16a8,8,0,0,0-8,8V424a8,8,0,0,0,8,8H40a8.006,8.006,0,0,0,7.43-5.03L61.42,392H450.58l13.99,34.97A8.006,8.006,0,0,0,472,432h24a8,8,0,0,0,8-8V256A8,8,0,0,0,496,248ZM152,224V112H360V224Zm136,16v8H224v-8ZM34.58,416H24V392H44.18ZM488,416H477.42l-9.6-24H488Zm0-40H24V264H488Z" />
				<path d="M128,360V280a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8v80a8,8,0,0,0,8,8h80A8,8,0,0,0,128,360Zm-16-8H48V288h64Z" />
				<path d="M72,312H88a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z" />
				<path d="M144,368H472a8,8,0,0,0,8-8V280a8,8,0,0,0-8-8H144a8,8,0,0,0-8,8v80A8,8,0,0,0,144,368Zm320-16H152V328H464ZM152,288H464v24H152Z" />
			</g>
		</svg>
	);
};

export default TvCabinetIcon;
